import axios from "axios";

/**
 * Fetch daily transaction tracker data from backend.
 * @param {Object} params - { sourceCountry, destinationCountry, fromDate, toDate }
 * @returns {Promise<Object>} - API response with chart and summary data
 */
export async function fetchDailyTransactionTracker(params = {}) {
  const res = await axios.get("/analytics/daily/transactions", { params });
  return res.data;
}

/**
 * Fetch all countries for populating source/destination filters.
 * @returns {Promise<Array>} - List of countries
 */
export async function fetchDailyTransactionCountries() {
  const res = await axios.get("/analytics/daily/countries");
  return res.data;
} 